module.exports = require("./chartsFactory.js")("Chart", require("highcharts"));



// WEBPACK FOOTER //
// ./src/components/ReactHighcharts/ReactHighcharts.js